const name = 'module/nextel';

export const GET_MODULES_CONFIGURATION_REQUEST = `${name}/GET_MODULES_CONFIGURATION_REQUEST`;
export const GET_MODULES_CONFIGURATION_SUCCESS = `${name}/GET_MODULES_CONFIGURATION_SUCCESS`;
export const GET_MODULES_CONFIGURATION_FAILURE = `${name}/GET_MODULES_CONFIGURATION_FAILURE`;

export const UPDATE_MODULES_CONFIGURATION_REQUEST = `${name}/UPDATE_MODULES_CONFIGURATION_REQUEST`;
export const UPDATE_MODULES_CONFIGURATION_SUCCESS = `${name}/UPDATE_MODULES_CONFIGURATION_SUCCESS`;
export const UPDATE_MODULES_CONFIGURATION_FAILURE = `${name}/UPDATE_MODULES_CONFIGURATION_FAILURE`;

export const GET_CHANNEL_LIST_REQUEST = `${name}/GET_CHANNEL_LIST_REQUEST`;
export const GET_CHANNEL_LIST_SUCCESS = `${name}/GET_CHANNEL_LIST_SUCCESS`;
export const GET_CHANNEL_LIST_FAILURE = `${name}/GET_CHANNEL_LIST_FAILURE`;

export const CREATE_CHANNEL_REQUEST = `${name}/CREATE_CHANNEL_REQUEST`;
export const CREATE_CHANNEL_SUCCESS = `${name}/CREATE_CHANNEL_SUCCESS`;
export const CREATE_CHANNEL_FAILURE = `${name}/CREATE_CHANNEL_FAILURE`;

export const DELETE_CHANNEL_REQUEST = `${name}/DELETE_CHANNEL_REQUEST`;
export const DELETE_CHANNEL_SUCCESS = `${name}/DELETE_CHANNEL_SUCCESS`;
export const DELETE_CHANNEL_FAILURE = `${name}/DELETE_CHANNEL_FAILURE`;

export default name;
